import { useEffect, useState } from "react"

import { StyleSheet, Font } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    page: {
        // flexDirection: 'row',
        // backgroundColor: '#E4E4E4'
        fontFamily: 'Times-Roman',
        padding: 20,
    },
    textDefault: {
        fontFamily: 'Times-Roman',
    },
    textBold: {
        fontFamily: 'Times-Bold'
    },
    textUpperCase: {
        textTransform: 'uppercase'
    },
    textAlignRight: {
        textAlign: 'right'
    },
    textCapitalize: {
        textTransform: 'capitalize'
    },
    // section: {
    //     margin: 10,
    //     padding: 10,
    //     flexGrow: 1
    // },
    h7: { fontSize: 7 },
    h8: { fontSize: 8 },
    h9: { fontSize: 9 },
    h10: { fontSize: 10 },
    h11: { fontSize: 11 },
    h12: { fontSize: 12 },
    h13: { fontSize: 13 },
    h14: { fontSize: 14 },
    h15: { fontSize: 15 },
    font: {
        fontSize: 9,
        fontFamily: 'HanSansCNLightLight'
    }
});